import React, { useState } from 'react';
import CompetitorAnalysisModal from './CompetitorAnalysisModal';
import BusinessProfilePopup from './BusinessProfilePopup';

const CompetitorAnalysisWithPopup = (props) => {
  const [selectedBusinessProfile, setSelectedBusinessProfile] = useState(null);
  const [showBusinessProfilePopup, setShowBusinessProfilePopup] = useState(false);

  const handleBusinessProfileClick = (competitor, gridData, formData) => {
    // Create grid data specific to this business
    const businessGridData = {
      ...gridData,
      results: gridData.results.map(result => {
        // Find this business in the result
        const businessInGrid = result.businesses.find(b => {
          const key = b.placeId || `${b.name}-${b.address}`;
          const competitorKey = competitor.placeId || `${competitor.name}-${competitor.address}`;
          return key === competitorKey;
        });

        // If business found, get its rank, otherwise null
        const businessRank = businessInGrid ? 
          result.businesses.findIndex(b => {
            const key = b.placeId || `${b.name}-${b.address}`;
            const competitorKey = competitor.placeId || `${competitor.name}-${competitor.address}`;
            return key === competitorKey;
          }) + 1 : null;

        return {
          ...result,
          targetBusinessRank: businessRank
        };
      })
    };

    setSelectedBusinessProfile({
      ...competitor,
      gridData: businessGridData,
      formData
    });
    setShowBusinessProfilePopup(true);
  };

  const handleClosePopup = () => {
    setShowBusinessProfilePopup(false);
    setSelectedBusinessProfile(null);
  };

  return (
    <>
      <CompetitorAnalysisModal 
        {...props}
        onBusinessProfileClick={handleBusinessProfileClick}
      />
      <BusinessProfilePopup
        isOpen={showBusinessProfilePopup}
        onClose={handleClosePopup}
        selectedBusiness={selectedBusinessProfile}
        formData={selectedBusinessProfile?.formData}
      />
    </>
  );
};

export default CompetitorAnalysisWithPopup;
